import actionTypes from '../constants/action-types';
import statuses from '../constants/statuses';
import getStatus from '../selectors/status';
import findFor from '../filters/find-for';
import block from '../actions/block';
import unblock from '../actions/unblock';
import events from '../../utils/events';

const interrupter = (store) => (next) => (action) => {
  if (action.type === actionTypes.UNBLOCK) {
    next(action);

    return;
  }

  const state = store.getState();
  const status = getStatus(state);
  if (status === statuses.BLOCKED) {
    return;
  }

  const interrupterEvents = findFor(action);

  if (interrupterEvents.length) {
    store.dispatch(block());

    events
      .emitSequentially(interrupterEvents)
      .then(() => {
        store.dispatch(unblock());
        next(action);
      })
      .catch(() => {
        store.dispatch(unblock());
      });
  } else {
    next(action);
  }
};

export default interrupter;
